// "Relationships" tab.
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';

export function Relationships(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Relationships"
      wiringNotes="Shows the customer's associated vet, farrier, trainer, and barn, sourced from services/relationships. Read-only in v1."
    />
  );
}
